module.exports = __webpack_public_path__ + "static/media/school.79d3ee95.svg";